<div class="notification">
  <div class="notification-header">
    {{ 'navigation.assetSearchOrderComplete' | transloco }}
    <button mat-icon-button (click)="removeNotification()" [attr.aria-label]="'navigation.closeNotification' | transloco"
      class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if(show) {
    <p>
      @if(numResults > 0) {
        {{ 'navigation.searchYieldedResults' | transloco: { serial: serialNumber, count: numResults } }}
      } @else {
        {{ 'navigation.searchNoResults' | transloco: { serial: serialNumber } }}
      }
    </p>
  }
  @if (notification.order?.id) {
    <button mat-button (click)="viewOrder()"
      [attr.aria-label]="'navigation.viewOrder' | transloco" class="close-button">
      {{ 'common.labels.view' | transloco }}
    </button>
  }
</div>